import request from '../utils/request'
import {get, set, del } from "../utils/localStorage";
import { app } from "../main.js";
import Qs from 'qs'
import { historyMock, customOrderMock } from './mock'

// baseurl
// export const imageBaseUrl = process.env.VUE_APP_IMAGE_URL;

//获取分享列表
export const getShareList = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/share/list`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

//获取分享详情
export const getShareDetail = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/share/detail`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}


//获取商品列表
export const getGoodsList = (data) => {
    console.log('getGoodsList');
    console.log(app.$i18n.locale);
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/product/list`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得商品详细
export const getGoodsDetail = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/product/detail`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 首頁取得個區塊的商品列表（推薦商品、熱門商品、新品上市、今日優惠）
// 取得的資料與使用getGoodsList api一樣，只是首頁這樣要呼叫太多次api，所以專門一隻api
export const getHomeGoodsList = () => {
    console.log('getGoodsList');
    console.log(app.$i18n.locale);
    const newData = {
        store_id: app.$route.query.store_id,
        lan: app.$i18n.locale,
        recommend: 6,
        hot: 12,
        new: 12,
        preferential: 12
    };
    return request({
        url: `/home/product`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

//获取商品小类
export const getGoodsInd = (data, _vue) => {
    console.log('getGoodsInd');
    console.log(_vue);
    console.log(_vue.$route);
    const newData = {...data, store_id: _vue.$route.query.store_id, lan: _vue.$i18n.locale };
    return request({
        url: `/product/ind`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

//获取商品小类
export const getProductSelect = (data) => {
    const newData = {...data, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/product/select`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}



//获取指南列表
export const getGuideList = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/guide/list`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

//获取指南详情
export const getGuideDetail = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/guide/detail`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

//获取指南小类
export const getGuideInd = (data, _vue) => {
    const newData = {...data, store_id: _vue.$route.query.store_id, lan: _vue.$i18n.locale };
    return request({
        url: `/document/ind`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

//获取banner图
export const getBanner = (data) => {
    const newData = {...data, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/banner?lan=tw`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

//获取分享详情
export const getActivityList = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/event/list`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

export const getActivityDetail = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/event/detail`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

//获取优惠商品
export const getPreferential = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/product/list`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 注册帐号
export const registerUser = (data) => {
    const newData = {...data, store_id: app.$route.query.store_id, lan: app.$i18n.locale };
    return request({
        url: `/registered`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 登入
export const loginUser = async(data, remember) => {
    const newData = {...data, store_id: app.$route.query.store_id };
    try {
        if (remember) {
            set('account', data.username);
        } else {
            del('account');
        }

        const loginResult = await request({
            url: `/login`,
            method: 'post',
            data: Qs.stringify(newData)
        })


        // 取得使用者资讯
        const userInfo = await request({
            url: `/session?token=${loginResult.token}`,
            method: 'post',
        })

        set('token', loginResult.token);
        set('userInfo', userInfo);
        app.$store.commit('SET_USER_INFO', userInfo);

        return Promise.resolve();
    } catch (error) {
        return Promise.reject();
    }
}

// 取得关注清单
export const getMemberLike = (data) => {
    const token = get('token');
    const newData = {...data, token, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/memberLike`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取消关注
export const addMemberLike = (data) => {
    const token = get('token');
    const newData = {...data, token, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/memberLikeAdd`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得通知
export const getNotifications = (data) => {
    const token = get('token');
    const newData = {...data, token, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/notifications`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 更新会员资料
export const updateMemberData = async(data) => {
    try {
        console.log('updateMemberData', data);
        const token = get('token');
        // 生日要串起来
        const birthday = `${data.year}-${data.mon}-${data.day}`;
        if (data.is_check) {
            data.province2 = data.province;
            data.area2 = data.area;
            data.city2 = data.city;
            data.zip2 = data.zip;
            data.ship_addr1 = data.address;
        }
        data.is_check = data.is_check ? 1 : 2;
        const newData = {...data, token, lan: app.$i18n.locale, birthday, store_id: app.$route.query.store_id };
        await request({
            url: `/memberEdit`,
            method: 'put',
            data: Qs.stringify(newData)
        })

        // 取得使用者资讯
        const userInfo = await request({
            url: `/session`,
            method: 'post',
            data: Qs.stringify({ token })
        })

        set('userInfo', userInfo);
        app.$store.commit('SET_USER_INFO', userInfo);

        return Promise.resolve();
    } catch (error) {
        return Promise.reject();
    }
}

export const getOrderList = (data) => {
    const token = get('token');
    console.log('data', data);
    // 计算要传什么日期过去
    const now = new Date();
    let searchDate = '';
    if (data.date) {
        switch (data.date) {
            case '1':
                // 一周
                now.setDate(now.getDate() - 7);
                break;
            case '2':
                // 一个月
                now.setMonth(now.getMonth() - 1);
                break;
            case '3':
                // 六个月
                now.setMonth(now.getMonth() - 6);
                break;
            case '4':
                // 一年
                now.setMonth(now.getMonth() - 12);
                break;
        }
        searchDate = `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}`;
    }

    const newData = {...data, token, lan: app.$i18n.locale, mode: '1', date: searchDate, store_id: app.$route.query.store_id };

    // return { order: historyMock(), status: 'ok' };

    return request({
        url: `/order/list`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

export const getCustomOrderList = (data) => {
    const token = get('token');
    console.log('data', data);
    // 计算要传什么日期过去
    const now = new Date();
    let searchDate = '';
    if (data.date) {
        switch (data.date) {
            case '1':
                // 一周
                now.setDate(now.getDate() - 7);
                break;
            case '2':
                // 一个月
                now.setMonth(now.getMonth() - 1);
                break;
            case '3':
                // 六个月
                now.setMonth(now.getMonth() - 6);
                break;
            case '4':
                // 一年
                now.setMonth(now.getMonth() - 12);
                break;
        }
        searchDate = `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}`;
    }

    const newData = {...data, token, lan: app.$i18n.locale, mode: '2', date: searchDate, store_id: app.$route.query.store_id };

    // return { order: customOrderMock(), status: 'ok', total: 100 };

    return request({
        url: `/order/list`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得历史订单内容
export const getOrderDetail = (data) => {
    const token = get('token');
    const newData = {...data, token, lan: app.$i18n.locale };
    return request({
        url: `/order/detail`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 销售据点
export const getLocations = (data) => {
    const token = get('token');
    const newData = {...data, token, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/store`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得销售据点的预约日期
export const getReserveDate = (data) => {
    const newData = {...data, lan: app.$i18n.locale };
    return request({
        url: `/reserveDate`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得销售据点的预约时间
export const getReserveTime = (data) => {
    const newData = {...data, lan: app.$i18n.locale };
    return request({
        url: `/reserveTime`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 关于订制内衣
export const getCustomAbout = () => {
    // const token = get('token');
    const newData = { lan: app.$i18n.locale };
    return request({
        url: `/tailor`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 3D立体测量介绍
export const getCustomIntro = () => {
    // const token = get('token');
    const newData = { lan: app.$i18n.locale };
    return request({
        url: `/tailor3D`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 当季新品
export const getSeasonNew = () => {
    // const token = get('token');
    const newData = { lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/seasonNews`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 预约测量
export const reserveCustom = (data) => {
    // const token = get('token');
    const newData = {...data, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/booking`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 测量记录
export const getCustomHistory = (data) => {
    const token = get('token');
    const newData = {...data, lan: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    console.log('newData', newData);
    return request({
        url: `/body`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 我的优惠券
export const getDiscounts = (data) => {
    const token = get('token');
    const newData = {...data, an: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    console.log('newData', newData);
    return request({
        url: `/discounts`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 首页版块api
export const getHomeAdv = (data) => {
    // const token = get('token');
    const newData = { lan: app.$i18n.locale, ...data, store_id: app.$route.query.store_id };
    console.log('newData', newData);
    return request({
        url: `/adv`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 忘记密码
export const sendForget = (data) => {
    // const token = get('token');
    const newData = { lan: app.$i18n.locale, ...data, store_id: app.$route.query.store_id };
    return request({
        url: `/forget`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得购物车
export const getCart = () => {
    const token = get('token');
    const newData = { lan: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    return request({
        url: `/shopcar`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得購物免運的條件
export const toteFees = () => {
    const token = get('token');
    const newData = { lan: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    return request({
        url: `/totefees`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 新增购物车
export const addCart = (data) => {
    const token = get('token');
    const newData = {...data, lan: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    return request({
        url: `/cartsAdd`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 搜寻商品
export const searchProduct = (data) => {
    // const token = get('token');
    const newData = {...data, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/search`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 删除商品
export const removeProduct = (data) => {
    const token = get('token');
    const newData = {...data, lan: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    return request({
        url: `/cartsRemove`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 更改密碼
export const changePWD = (data) => {
    console.log(data);
    const token = get('token');
    const newData = {...data, lan: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    return request({
        url: `/change`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得验证码
export const getCode = (data) => {
    console.log(data);
    const newData = {...data, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/getCode`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 检查验证码
export const verifyCode = (data) => {
    console.log(data);
    const newData = {...data, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/verifyCode`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得问答分类
export const getQACate = () => {
    const data = {
        store_id: app.$route.query.store_id,
        count: 1000,
        lan: app.$i18n.locale
    };
    return request({
        url: `/qaind`,
        method: 'post',
        data: Qs.stringify(data)
    })
}

// 取得问与答列表
export const getQuestions = (data) => {
    console.log(data);
    const newData = {
        ...data,
        store_id: app.$route.query.store_id,
        lan: app.$i18n.locale
    };
    return request({
        url: `/question`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得问与答详细
export const getQuestionDetail = (data) => {
    console.log(data);
    const newData = {...data, lan: app.$i18n.locale, store_id: app.$route.query.store_id };
    return request({
        url: `/question/detail`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得问与答详细
export const searchQ = (data) => {
    console.log(data);
    const newData = {
        ...data,
        count: 10000,
        store_id: app.$route.query.store_id,
        lan: app.$i18n.locale
    };
    return request({
        url: `/qasearch`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 建立订单
export const cartsConfirm = (data) => {
    console.log(data);
    const token = get('token');
    const newData = {...data, token, store_id: app.$route.query.store_id };
    return request({
        url: `/cartsConfirm`,
        method: 'put',
        data: Qs.stringify(newData)
    })
}

// 建立订单
export const cartsCheckout = (data) => {
    console.log(data);
    const token = get('token');
    const newData = {...data, token, store_id: app.$route.query.store_id };
    return request({
        url: `/cartsCheckout`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 微信登入
export const wxLogin = (data) => {
    console.log(data);
    const newData = {...data };
    return request({
        url: `/wx`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取得预约记录
export const getReservation = (data) => {
    console.log(data);
    const token = get('token');
    const newData = {...data, lan: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    return request({
        url: `/reservation`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取消预约
export const cancelReservation = (data) => {
    console.log(data);
    const token = get('token');
    const newData = {...data, lan: app.$i18n.locale, token, store_id: app.$route.query.store_id };
    return request({
        url: `/cancel`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}

// 取消预约
export const getSystemSetup = (data) => {
    console.log(data);
    const token = get('token');
    const newData = {...data };
    return request({
        url: `/systemsetup`,
        method: 'post',
        data: Qs.stringify(newData)
    })
}